// extracted by mini-css-extract-plugin
module.exports = {"image":"image-text-card-block_image__tUOvP","image--compact":"image-text-card-block_image--compact__qBz5L"};